import { message } from 'antd';

export const handleMessage = (message: any, type: string, content: string) => {
  switch (type) {
    case 'success':
      message.success(content);
      break;
    case 'error':
      message.error(content);
      break;
    case 'warning':
      message.warning(content);
      break;
    default:
      message.success(content);
  }
};

export const showStringErrorMessage = (msg: string) => {
  handleMessage(message, 'error', msg);
};

// * API 에러 메세지 보여주기
export const showApiErrorMessage = (err) => {
  let errorMessage: string = err?.response?.data?.message;

  if (!errorMessage) {
    errorMessage = '알 수 없는 오류';
  }

  handleMessage(message, 'error', errorMessage);
};

export const showApiSuccessMessage = (successText) => {
  handleMessage(message, 'success', successText);
};
